import script from "./dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=225baeda&lang=scss&scoped=true"
import "./dashboard.vue?vue&type=style&index=1&id=225baeda&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225baeda"]])

export default __exports__